module.exports = __webpack_public_path__ + "static/media/right.ec40e77b.svg";